import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import axios from "axios";
import { useHistory } from "react-router-dom";
import Select from "react-select";
import DataTable from "react-data-table-component";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { API_BASE_URL } from "../../../config";
import Pagination from "../../Pagination/Paginations";
import EntriesSelector from "../../Pagination/EntriesSelector";
import {
  statisticsAction,
  statisticsCloseAction,
} from "../../../actions/settingsAction";

const Add_department = (props) => {
  const { fixNavbar } = props;
  const history = useHistory();

  /* ================= STATE ================= */
  const [formData, setFormData] = useState({
    department_name: "",
    dept_head: "",
  });

  const [user, setUser] = useState({
    department_name: "",
    dept_head: "",
    department_id: "",
  });

  const [data, setData] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);
  const savingRef = useRef(false);
  const updatingRef = useRef(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [entriesPerPage, setEntriesPerPage] = useState(10);

  const emptyMenu = {
    department_name: "",
    dept_head: "",
    department_id: "",
  };

  /* ================= FETCH DATA ================= */
  useEffect(() => {
    fetchDepartments();
    fetchEmployees();
  }, []);

  const fetchDepartments = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${API_BASE_URL}/department_list`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      });
      setData(res.data.data.leave_type || []);
    } catch (err) {
      toast.error("Failed to load departments");
    } finally {
      setLoading(false);
    }
  };

  const fetchEmployees = async () => {
    try {
      const res = await axios.get(`${API_BASE_URL}/all_employees`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      });
      setEmployees(res.data.data.all_employee || []);
    } catch (err) {
      toast.error("Failed to load employees");
    }
  };

  /* ================= HANDLERS ================= */
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSelectChange = (selected) => {
    setFormData({ ...formData, dept_head: selected?.value || "" });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // block repeat submits while a save request is already running
    if (savingRef.current) return;

    savingRef.current = true;
    setIsSaving(true);

    try {
      const res = await axios.post(
        `${API_BASE_URL}/add_department`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        }
      );

      if (res.data.status === "success") {
        toast.success(res.data.message);
        fetchDepartments();
        setFormData({ department_name: "", dept_head: "" });
      } else {
        // toastId stops the same validation error stacking on repeat clicks
        toast.error(res.data.message, { toastId: "add-department" });
      }
    } catch (err) {
      toast.error(err.response?.data?.message || "Error occurred", { toastId: "add-department" });
    } finally {
      savingRef.current = false;
      setIsSaving(false);
    }
  };

  const handleUpdate = async (department_id) => {
    try {
      const res = await axios.get(
        `${API_BASE_URL}/showdepartment/${department_id}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        }
      );
      setUser(res.data);
    } catch (err) {
      toast.error("Failed to fetch department");
    }
  };

const handleEditSubmit = async (e) => {
  e.preventDefault();

  // block repeat submits while an update request is already running
  if (updatingRef.current) return;

  updatingRef.current = true;
  setIsUpdating(true);

  try {
    const res = await axios.post(
      `${API_BASE_URL}/updatedepartment`,
      {
        department_id: user.department_id,
        department_name: user.department_name,
        dept_head: user.dept_head,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      }
    );

    if (res.data.status === "success") {
      toast.success(res.data.message);

      // ✅ reload table data only
      await fetchDepartments();

      // ✅ close modal
      window.$("#exampleEditModal").modal("hide");

      // ✅ reset form
      setUser({
        department_id: "",
        department_name: "",
        dept_head: "",
      });
    } else {
      toast.error(res.data.message, { toastId: "update-department" });
    }
  } catch (err) {
    toast.error("Update failed", { toastId: "update-department" });
  } finally {
    updatingRef.current = false;
    setIsUpdating(false);
  }
};

  /* ================= FILTER ================= */
  const filteredData = data.filter((item) =>
    `${item.department_name}${item.name}`
      .toLowerCase()
      .includes(searchTerm.toLowerCase())
  );

  /* ================= PAGINATION ================= */
  const totalPages = Math.ceil(filteredData.length / entriesPerPage);
  const indexOfLast = currentPage * entriesPerPage;
  const indexOfFirst = indexOfLast - entriesPerPage;
  const currentData = filteredData.slice(indexOfFirst, indexOfLast);

  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm]);

  /* ================= DATATABLE COLUMNS ================= */
  const columns = [
    
   
    {
      name: "Department Name",
      selector: (row) => row.department_name,
      sortable: true,
    },
    {
      name: "Department Head",
      selector: (row) => row.name,
      sortable: true,
    },
    {
      name: "Count",
      selector: (row) => row.count,
      center: true,
    },
    {
      name: "Action",
      cell: (row) => (
        <button
          className="btn btn-sm btn-icon"
          data-toggle="modal"
          data-target="#exampleEditModal"
          onClick={() => {
            handleUpdate(row.department_id);
            setUser(emptyMenu);
          }}
        >
          <i className="fa fa-edit" />
        </button>
      ),
      button: true,
    },
  ];

  /* ================= RENDER ================= */
  return (
    <>
	 <ToastContainer position="bottom-right" />

      <div className={`section-body ${fixNavbar ? "marginTop" : ""}`}>
        <div className="container-fluid px-4 px-lg-5">

          {/* ===== ADD DEPARTMENT FORM ===== */}
          <div className="card mb-4">
            <div className="card-header">
              <h3 className="card-title d-flex align-items-center mb-0" style={{ color: "#1d3a8a", fontWeight: 600 }}>
                <i className="fa fa-building mr-2" style={{ fontSize: "20px" }} />
                Add Department
              </h3>
            </div>
            <div className="card-body">
              <form onSubmit={handleSubmit}>
                <div className="row align-items-end">

                  <div className="col-md-4">
                    <label>Department Name</label>
                    <input
                      type="text"
                      className="form-control required-input"
                      name="department_name"
					    placeholder="Department "
                      value={formData.department_name}
                      onChange={handleChange}
                      
                    />
                  </div>

                  <div className="col-md-4">
                    <label>Department Head</label>
                    <Select classNames={{
    control: () => "required-select required-tooltip"
  }}
                      options={employees}
                      onChange={handleSelectChange}
                      placeholder="Department Head"
                      menuPortalTarget={document.body}
                      styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                    />
                  </div>

                  <div className="col-md-2">
                    <button className="btn btn-primary btn-sm" disabled={isSaving}>
                      {isSaving ? "Adding..." : "Add"}
                    </button>
                  </div>

                </div>
              </form>
            </div>
          </div>

          {/* ===== DEPARTMENT LIST ===== */}
          <div className="card">
            <div className="card-header d-flex justify-content-between align-items-center">
              <h3 className="card-title d-flex align-items-center mb-0" style={{ color: "#1d3a8a", fontWeight: 600 }}>
                <i className="fa fa-building mr-2" style={{ fontSize: "20px" }} />
                Department List
              </h3>
              <div style={{ display: "flex", alignItems: "center" }}>
                <EntriesSelector
                  entriesPerPage={entriesPerPage}
                  setEntriesPerPage={setEntriesPerPage}
                  setCurrentPage={setCurrentPage}
                />
                <div style={{ marginLeft: "15px" }}>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    style={{ width: "200px" }}
                    placeholder="Search"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                </div>
              </div>
            </div>

            <div className="card-body">
            <DataTable
  columns={columns}
  data={currentData}
  highlightOnHover
  striped
  responsive
  persistTableHead
  fixedHeader
  fixedHeaderScrollHeight="400px"
/>

              <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={setCurrentPage}
              />
            </div>
          </div>

        </div>
      </div>

      {/* ===== EDIT MODAL ===== */}
      <div
        className="modal fade"
        id="exampleEditModal"
        tabIndex="-1"
        role="dialog"
      >
        <form onSubmit={handleEditSubmit}>
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5>Edit Department</h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                >
                  ×
                </button>
              </div>
              <div className="modal-body">
                <input
                  type="text"
                  className="form-control mb-2"
                  value={user.department_name}
                  onChange={(e) =>
                    setUser({ ...user, department_name: e.target.value })
                  }
                />

                <Select
                  options={employees}
                  value={
                    employees.find(
                      (e) => e.value === user.dept_head
                    ) || null
                  }
                  onChange={(selected) =>
                    setUser({ ...user, dept_head: selected.value })
                  }
                  menuPortalTarget={document.body}
                  styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                />
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" data-dismiss="modal">
                  Close
                </button>
                <button className="btn btn-primary" disabled={isUpdating}>
                  {isUpdating ? "Saving..." : "Save"}
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  fixNavbar: state.settings.isFixNavbar,
});

export default connect(mapStateToProps, {
  statisticsAction,
  statisticsCloseAction,
})(Add_department);
